import { render, staticRenderFns } from "./TJDetailTitle.vue?vue&type=template&id=1c2662e0&scoped=true&"
import script from "./TJDetailTitle.vue?vue&type=script&lang=js&"
export * from "./TJDetailTitle.vue?vue&type=script&lang=js&"
import style0 from "./TJDetailTitle.vue?vue&type=style&index=0&id=1c2662e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2662e0",
  null
  
)

export default component.exports